import { Typography } from "@material-ui/core"
import { CarModelsPriceListPageResponse } from "api"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"
import { StyledHeaderH1 } from "../../reusable/wrappers/CenterText"
import ImageContainer from "../../reusable/wrappers/ImageContainer"
import CarListWrapper from "./CarListWrapper"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
  }
`

const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
  input {
    padding-left: 0px;
    padding-right: 0px;
    background-color: white;
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .MuiTextField-root {
    margin-top: 20px;
    width: 320px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: 100%;
    }
  }
`

const StyledTextWrapp = styled.div`
  margin-top: 40px;
  width: 1160px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 20px;
    padding-left: 20px;
    width: 100%;
  }
`

const StyledSpace = styled.div`
  height: 60px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    height: 0px;
  }
`
const StyledBody = styled(Typography).attrs({ variant: "body1" })`
  font-family: "OENaPro";
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 27px;
  color: ${(p) => p.theme.colors.black};
  width: 985px;
  margin: auto;
  text-align: center;
  margin-top: 20px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    margin-top: 10px;
  }
`

type Props = {
  modelsData: CarModelsPriceListPageResponse
}

const CarListPage = ({ modelsData }: Props) => {
  const isDesktop = useIsDesktop()
  const title = "מחירון דגמי מאזדה"
  const headerText = modelsData?.annualPriceCatalogText
  return (
    <StyledWrapper>
      {/* Modal to show response data START */}

      <StyledPageDiv>
        <ImageContainer
          src={isDesktop ? "/img/carprice.jpg" : "/img/carpricemobile.jpg"}
        />
        <BreadCrumbsWrapper name="CarList" />
        <StyledTextWrapp>
          <StyledHeaderH1 $align="center">{title}</StyledHeaderH1>

          <StyledBody>{headerText}</StyledBody>
        </StyledTextWrapp>
        <StyledSpace />
        {modelsData.carModels.map((carModel, index) => (
          <CarListWrapper
            modelsData={modelsData}
            carModel={carModel}
            index={index}
            additionalPriceForColor={modelsData?.additionalPriceForColor}
            key={index}
          />
        ))}
      </StyledPageDiv>
    </StyledWrapper>
  )
}

export default CarListPage
